import ChipIcon from './ChipIcon';
import StatusPill from './StatusPill';

const EsgRatingsBySource = ({
    t,
    ratings,
}) => (
    <>
        <div className="d-flex align-items-center gap-2 mb-2">
            <h6 className="overview-esg-rating__table-title mb-0">
                {t('ESG Ratings by Source')}
            </h6>
            <ChipIcon />
        </div>

        <div className="table-responsive overview-esg-rating__table-wrapper">
            <table className="table overview-esg-rating__table mb-0">
                <thead>
                    <tr>
                        <th>{t('Source')}</th>
                        <th>{t('HUGO BOSS Rating')}</th>
                        <th>{t('Assessment')}</th>
                    </tr>
                </thead>
                <tbody>
                    {(ratings || []).map((row) => (
                        <tr key={row.source}>
                            <td>{row.source}</td>
                            <td>
                                <span className="overview-esg-rating__rating-link">
                                    {row.rating}
                                </span>
                            </td>
                            <td>
                                <StatusPill
                                    label={t(row.assessment)}
                                    color={row.assessmentColor}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </>
);

export default EsgRatingsBySource;
